import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { initTelegram } from './lib/telegram.js';
import './styles.css';

initTelegram();

const root = document.getElementById('root');
if (!root) throw new Error('Не найден #root — сломан index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
